'use client';
import React from 'react';
import PropTypes from 'prop-types';
import {PayPalScriptProvider} from '@paypal/react-paypal-js';

import PaypalInitializer from './PaypalInitializer';

const PaypalProvider = ({components, enableFunding, currencyCode, locale, paypalClientId, btToken, children}) => {
  return (
    <PayPalScriptProvider
      options={{
        intent: 'authorize',
        currency: currencyCode,
        locale: locale?.replace('-', '_'),
        components,
        enableFunding,
      }}
      deferLoading
    >
      <PaypalInitializer paypalClientId={paypalClientId} btToken={btToken} />
      {children}
    </PayPalScriptProvider>
  );
};

PaypalProvider.propTypes = {
  /** Components to initialize in the SDK */
  components: PropTypes.string.isRequired,

  /** Funding sources to enable in the SDK */
  enableFunding: PropTypes.string,

  /** Currency code to initialize the SDK */
  currencyCode: PropTypes.string,

  /** Locale code to initialize the SDK */
  locale: PropTypes.string,

  /** The paypal client id */
  paypalClientId: PropTypes.string,

  /** The braintee token */
  btToken: PropTypes.string,

  /** Children to render inside */
  children: PropTypes.node,
};

export default PaypalProvider;
